export const buildEntityName = (
  fname: string = '',
  lname: string = '',
  spouse_fname?: string,
  spouse_lname?: string,
): string => {
  if (spouse_fname && spouse_lname && spouse_lname !== lname) {
    return `${lname}, ${fname} and ${spouse_lname}, ${spouse_fname}`;
  } else if (spouse_fname && spouse_lname && spouse_lname === lname) {
    return `${lname}, ${fname} and ${spouse_fname}`;
  } else {
    return `${lname}, ${fname}`;
  }
};

// "John, Doe", "hashId" to john-doe-hashid
export const getCompanyHash = (
  name: string,
  hashId: string,
): string | undefined => {
  if (!name || !hashId) return undefined;

  const flatName: string = name
    .toLowerCase()
    .split(', ')
    .join('-')
    .replace(/\./g, '');

  return `${flatName}-${hashId}`;
};

// "john-doe-hashId" to hashId
export const getHash = (hashString?: string): string | undefined => {
  if (!hashString) return undefined;

  const flatHash: Array<string> = hashString?.split('-');
  const hash: string = flatHash[flatHash.length - 1];

  return hash;
};
